<template>
  <div class="row">
    <div class="col-lg-12">
      <ul class="mb-0">
        <li
          v-for="(option, index) in ['Sim', 'Não']"
          :key="index"
          class="li_style_none"
        >
          <span
            :class="{ 'font-weight-bold': isMarked(index) }"
            class="d-inline"
          >
            {{ isMarked(index) ? `* ${option}` : option }}
          </span>
          <RightOrWrongIcons
            :hide="
              question &&
              question.choices &&
              question.choices.correctAnswer == 'any'
            "
            :rightIf="
              question &&
              question.choices &&
              question.choices.correctAnswer == options[index]
            "
            :useSvg="useSvg"
            :wrongIf="
              question &&
              question.choices &&
              question.choices.correctAnswer != options[index] && isMarked(index)
            "
            ParentDivClasses="d-inline"
          />
        </li>
      </ul>
    </div>
    <div class="col-lg-12">
      <span class="f14">(<b>*</b>) Opção que o candidato(a) marcou</span>
    </div>
  </div>
</template>

<script>
import RightOrWrongIcons from "components/RightOrWrongIcons.vue";

export default {
  components: { RightOrWrongIcons },
  props: {
    answer: {
      type: Object,
      default: () => ({ choices: { marked: [] }, question: { choices: {} } }),
      required: true,
    },
    useSvg: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      options: ["yes", "no"],
    };
  },
  computed: {
    question() {
      return this.answer && this.answer.question
        ? this.answer.question
        : { choices: {} };
    },
  },
  methods: {
    isMarked(index) {
      return (
        this.answer &&
        this.answer.choices &&
        Array.isArray(this.answer.choices.marked) &&
        this.answer.choices.marked[0] === this.options[index]
      );
    },
  },
};
</script>
